import { useSelector } from "react-redux";
import { State } from "../../../state/store";
import { DateTime } from "../../../domain/fundamental/DateTime";
import { FAQ } from "../../../domain/faq/FAQ";
import { FAQId } from "../../../domain/faq/FAQId";
import { FAQTitle } from "../../../domain/faq/FAQTitle";
import { FAQContent } from "../../../domain/faq/FAQContent";

export const useFAQList = (): FAQ[] | null => {
    const responseJsonArray = useSelector((state: State) => state.faq.faqList);

    return responseJsonArray ? responseJsonArray.map(responseJson => (
        FAQ.from(
            FAQId.fromString(responseJson.id),
            FAQTitle.fromString(responseJson.title),
            FAQContent.fromString(responseJson.content),
            DateTime.fromString(responseJson.createdTime)
        )
    )) : null;
};
